// Cinematic Experience — data source of truth.
// Each station appears both in the right-rail nav and inside the StaggeredMenu.

export const SITE = {
  baseUrl: 'https://radiusconsulting.co.za',
  brand: 'RADIUS',
  wordmark: 'Radius',
};

export const MENU = [
  {
    id: 'solutions',
    label: 'Solutions',
    tagline: 'What we build',
    blurb: 'Deep marketing and brand expertise, accelerated by in-house AI execution.',
    href: '/solutions',
    cards: [
      {
        title: 'AI-Powered Growth',
        subtitle: 'More output. More intelligence. Less overhead.',
        body: 'Marketing automations, AI-assisted campaigns and always-on funnels that compound while your team sleeps.',
      },
      {
        title: 'Brand, Marketing & Design',
        subtitle: 'Built to be recognised. Designed to perform.',
        body: 'Brand strategy, identity systems and creative execution wired to a growth engine, not a mood board.',
      },
      {
        title: 'Go-To-Market & Commerce',
        subtitle: 'From idea to market. From market to revenue.',
        body: 'Positioning, launch playbooks and e-commerce builds that turn ambition into transactions.',
      },
    ],
  },
  {
    id: 'work',
    label: 'Work',
    tagline: 'Results That Speak',
    blurb: 'Real clients. Real challenges. Real impact.',
    href: '/portfolio',
    caseStudies: [
      { category: 'FMCG', title: 'Cadbury Dairy Milk South Africa', subtitle: 'National generosity movement, activated in-store', slug: 'cadbury-dairy-milk-south-africa' },
      { category: 'E-Commerce', title: 'Rentoza', subtitle: 'Subscription commerce, engineered for retention', slug: 'rentoza' },
      { category: 'E-Commerce', title: 'The Hawker', subtitle: 'Retail challenger brand, launched into the mainstream', slug: 'the-hawker' },
      { category: 'Lifestyle & Loyalty', title: 'The ENTERTAINER', subtitle: 'A loyalty ecosystem re-positioned for growth', slug: 'the-entertainer' },
      { category: 'Fintech', title: 'Lula', subtitle: 'A B2B fintech brand made unmissable', slug: 'lula' },
      { category: 'Retail & E-commerce', title: 'GreenLife Retail', subtitle: 'Omnichannel retail with a clearer point of view', slug: 'greenlife-retail' },
    ],
  },
  {
    id: 'company',
    label: 'Company',
    tagline: 'Ambition is nothing without execution',
    blurb: 'We turn ideas for growth into reality.',
    href: '/about',
    values: [
      { icon: 'Target', title: 'Connected Thinking', body: 'Strategy, design and execution engineered as one system, not three disconnected departments.' },
      { icon: 'Zap', title: 'In Motion', body: 'Ideas that ship, not decks that sit. We optimise for outcomes measured in weeks, not quarters.' },
      { icon: 'Sparkles', title: 'Proof, Not Promises', body: 'Every recommendation is backed by data and evidenced by work we can show.' },
    ],
    clients: ['Coca-Cola', 'Samsung', 'HSBC', 'Mastercard', 'IKEA', 'Unilever', 'Nestlé', 'Toyota', 'Vodafone', 'P&G'],
  },
  {
    id: 'blog',
    label: 'Blog',
    tagline: 'Insights & Perspectives',
    blurb: 'Strategy, creativity, and the future of brand marketing.',
    href: '/blog',
    posts: [
      { title: 'The Sale Is Where E-Commerce Starts, Not Where It Ends', category: 'E-Commerce', readTime: '4 min read', slug: 'e-commerce-south-africa-smme-post-checkout-2026' },
      { title: 'Most SMME Growth Plans Fail Before They Start', category: 'Go-To-Market', readTime: '4 min read', slug: 'go-to-market-strategy-south-africa-smme-focus-2026' },
      { title: 'Your Best Retail Channel Is a Person, Not a Platform', category: 'Retail & Last-Mile Experience', readTime: '4 min read', slug: 'retail-experience-south-africa-frontline-is-the-channel-2026' },
      { title: 'Brand Strategy Is Back on the Boardroom Agenda', category: 'Brand Strategy', readTime: '4 min read', slug: 'brand-strategy-south-africa-smme-cheapest-growth-lever-2026' },
      { title: 'Ten Thousand Tools, Five That Matter', category: 'AI-Powered Growth', readTime: '5 min read', slug: 'ai-tools-for-small-business-south-africa-lean-stack-2026' },
      { title: 'Frontier AI, Founder Budget: What Meta\u2019s Latest Ads Research Means for SMMEs', category: 'AI-Powered Marketing', readTime: '5 min read', slug: 'meta-ads-ai-south-africa-smme-2026' },
    ],
  },
  {
    id: 'resources',
    label: 'Resources',
    tagline: 'Templates, Tools & Playbooks',
    blurb: 'Practical downloads for founders and marketing teams — from launch checklists to brand audits.',
    href: '/resources',
    highlights: [
      { title: 'Resource Library', body: 'Guides, templates and playbooks across brand, growth, and go-to-market.' },
      { title: 'Free Downloads', body: 'Curated frameworks you can apply the same day you download them.' },
      { title: 'Gated Deep-Dives', body: 'Full research reports and playbooks delivered straight to your inbox.' },
    ],
  },
  {
    id: 'contact',
    label: 'Contact',
    tagline: "Let's start a conversation",
    blurb: 'Send us a note or book a call — we typically respond within 24 hours.',
    href: '/contact',
    details: {
      email: 'mishaan@radiusconsulting.co.za',
      phone: '083 777 0914',
      phoneHref: 'tel:0837770914',
      location: 'Johannesburg, SA \u00b7 Remote-friendly',
      hours: ['Mon\u2013Fri 9:00\u201318:00', 'Sat\u2013Sun Closed'],
    },
  },
];

export const FOOTER = {
  columns: [
    {
      title: 'Solutions',
      links: [
        { label: 'AI-Powered Growth', openStation: 'solutions' },
        { label: 'Brand Marketing & Design', openStation: 'solutions' },
        { label: 'Go-To-Market & Commerce', openStation: 'solutions' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', to: '/about' },
        { label: 'Case Studies', openStation: 'work' },
        { label: 'Our Process', to: '/process' },
        { label: 'Blog', openStation: 'blog' },
        { label: 'Careers', to: '/careers' },
      ],
    },
    {
      title: 'Resources',
      links: [
        { label: 'Resource Library', to: '/resources' },
        { label: 'Contact', openStation: 'contact' },
        { label: 'Legal & Policies', to: '/legal' },
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Cookie Policy', to: '/cookie-policy' },
        { label: 'Terms of Service', to: '/terms-of-service' },
      ],
    },
  ],
};
